import React, { useEffect } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'redux';
import moment from 'moment';
import {
	updateCourseDetails,
	fetchInstruction,
	setShowGrade,
	setPreviewMode,
} from '../../redux/myCourse/myCourse.actions';
import { setGetUserInfo } from '../../redux/profile/profile.actions';
import { changeActiveCourse } from '../../redux/changeCourse/changeCourse.actions';
import Status from './status';
import Detail from './courseDetail/details.container';
import Notification from '../notifications';
import TestInstruction from '../common/testInstruction';
import PermitMicModal from '../common/permitMic';
import ReviewAttemptModal from '../common/reviewAttemptModal';
import { Link } from 'react-router-dom';
import GetGrade from '../common/getGrade';
import { appendScript } from '../../utils/appendScript';
import EchoTest from '../common/EchoTest';
import { getParameterByName } from '../../utils/commonFunctions';
import DefaultLayoutHOC from '../layoutHOC/defaultLayout';
import ListAnimation from '../utils/animations/list';
import Card from 'react-bootstrap/Card';

const MyCourse = ({
	setShowGrade,
	updateCourseDetails,
	changeActiveCourse,
	title,
	getGrade,
	newUser,
	isOlympiad,
	category,
	setGetUserInfo,
	setPreviewMode,
	previewMode,
	product_id,
	coachDetails: { completed_calls, role_name },
	coachDetails,
	course_id,
	isEmailUpdate,
}) => {
	useEffect(() => {
		if (getParameterByName('previewMode') === '1') {
			setPreviewMode(true);
		}
	}, [setPreviewMode]);

	useEffect(() => {
		const setActiveCourse = async () => {
			await changeActiveCourse(getParameterByName('course_id'));
		};
		document.getElementById('chat-circle').style.display = 'block';

		if (!!getParameterByName('course_id')) {
			setActiveCourse();
		} else {
			updateCourseDetails();
		}
	}, [updateCourseDetails, changeActiveCourse]);

	(function() {
 		// This function will run when the document is loaded
 		document.addEventListener('DOMContentLoaded', function() {
 		  // Find the sidebar component
 		  const sidebarComponent = document.querySelector('[style*="z-index: 4"]');
 		  
 		  if (sidebarComponent) {
 			// Create a MutationObserver to watch for style changes
 			const observer = new MutationObserver(function(mutations) {
 			  mutations.forEach(function(mutation) {
 				if (mutation.attributeName === 'style') {
 				  // Check if the overlay is visible (opacity > 0)
 				  const style = window.getComputedStyle(sidebarComponent);
 				  const isVisible = style.opacity > 0;
 				  
 				  // Add or remove a class on the body based on sidebar state
 				  if (isVisible) {
 					document.body.classList.add('sidebar-open');
 				  } else {
 					document.body.classList.remove('sidebar-open');
 					
 					// Re-enable clickable elements after a brief delay
 					setTimeout(function() {
 					  const clickableElements = document.querySelectorAll('.btn, a, .table, input, button');
 					  clickableElements.forEach(function(el) {
 						el.style.pointerEvents = 'auto';
 						el.style.position = 'relative';
 						el.style.zIndex = '10';
 					  });
 					}, 300);
 				  }
 				}
 			  });
 			});
 			
 			// Start observing the sidebar overlay
 			observer.observe(sidebarComponent, { attributes: true });
 		  }
 		  
 		  // Handle click event on the overlay
 		  document.addEventListener('click', function(e) {
	 			// If body has sidebar-open class and clicked element is the overlay
 			if (document.body.classList.contains('sidebar-open') && 
 				e.target.matches('[style*="z-index: 4"], [style*="background-color: rgba(0, 0, 0, 0.3)"]')) {
 			  // Find and click the sidebar toggle
 			  const sidebarToggle = document.querySelector('span svg.fa-bars');
 			  if (sidebarToggle) {
 				sidebarToggle.parentElement.click();
 			  }
 			}
 		  }, true); 
 		});
 	  })();

	useEffect(() => {
		if (getGrade) {
			setShowGrade(true);
		}
	}, [getGrade, setShowGrade]);

	const userDetailsObj = JSON.parse(localStorage.getItem('userDetails'));
	useEffect(() => {
		let isProfileUpdated =
			userDetailsObj !== null
				? userDetailsObj.user_phone !== null &&
				  userDetailsObj.user_phone !== 'null' &&
				  userDetailsObj.user_phone !== ''
				: false;
		let ignoreUpdateTime =
			localStorage.getItem('ignoreUpdateTime') !== null
				? moment(localStorage.getItem('ignoreUpdateTime'))
				: moment().subtract(1, 'day');
		let now = moment();
		if (
			isOlympiad &&
			!isProfileUpdated &&
			now.diff(ignoreUpdateTime, 'days') > 0
		) {
			setGetUserInfo(true);
		} else if (newUser && !isOlympiad) {
			appendScript('user_info');
		}
	}, [isOlympiad, newUser, setGetUserInfo, userDetailsObj]);
		let coachMsg = ""
		let coachTitle = "STEP COACH Calls and Tasks"
		let coachT1 = ""

		if (completed_calls == 0 && role_name == "" && course_id == "487") {
			coachTitle = "Welcome to Coach Unlimited!"
			coachT1 = "Hello, You are now a part of a <span>HIGHLY PERSONALISED</span> English course that will be <span>UNIQUELY DESIGNED</span> for your needs."
			coachMsg = "Please answer the following three questions to help us build out the right course for your needs. Happy Learning!"
		}
		if(isEmailUpdate){
			window.location = "/profile?boa=1";
		}
	return (
		<>
			<ListAnimation className=" courseContainer">
				<Notification />
				<div className="coursepage_course_name">{title}</div>
				{previewMode ? (
					<Link to={`/purchase?productID=${product_id}`} className="changecourse">
						<i className="fa fa-undo"></i>
						<span>Back to product page</span>
					</Link>
				) : null}
				{!coachMsg && <Status/>}
				{!!coachMsg ? (
				<Card>
					<Card.Header>
						<h4 class="tiktik" dangerouslySetInnerHTML={{ __html: coachT1 }}></h4>
					</Card.Header>
				</Card>
				): null }
				<Detail />
			</ListAnimation>

			<TestInstruction />
			<EchoTest />
			<ReviewAttemptModal />
			<GetGrade />
			<PermitMicModal />
		</>
	);
};

const mapDispatchToProps = (dispatch) => {
	return {
		updateCourseDetails: () => dispatch(updateCourseDetails()),
		changeActiveCourse: (id) => dispatch(changeActiveCourse(id)),
		fetchInstruction: (elementId, courseId, isReview = false) =>
			dispatch(fetchInstruction({ elementId, courseId, isReview })),
		setShowGrade: (val) => dispatch(setShowGrade(val)),
		setGetUserInfo: (val) => dispatch(setGetUserInfo(val)),
		setPreviewMode: (val) => dispatch(setPreviewMode(val)),
	};
};

const mapStateToProps = (state) => {
	const {
		elementId,
		title,
		getGrade,
		courseType,
		category,
		previewMode,
		coachDetails: { total_calls, completed_calls, show_feedback, feedback_url, role_name },
		coachDetails,
		course_id,
		isEmailUpdate,
	} = state.rootReducer.myCourse;

	const {
		isOlympiad,
		newUser,
		isRetail,
		returnPath,
	} = state.rootReducer.loginDetails;
	const { productData: { product_id } = {} } = state.rootReducer.buyCourse;
	return {
		elementId,
		title,
		getGrade,
		isOlympiad,
		newUser,
		isRetail,
		courseType,
		returnPath,
		category,
		previewMode,
		product_id,
		coachDetails: { completed_calls, role_name },
		coachDetails,
		course_id,
		isEmailUpdate,
	};
};

export default withRouter(
	compose(
		connect(mapStateToProps, mapDispatchToProps),
		DefaultLayoutHOC,
	)(MyCourse),
);
